import { render, staticRenderFns } from "./ReviewList.vue?vue&type=template&id=34460e2b&scoped=true&"
import script from "./ReviewList.vue?vue&type=script&lang=js&"
export * from "./ReviewList.vue?vue&type=script&lang=js&"
import style0 from "./ReviewList.vue?vue&type=style&index=0&id=34460e2b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34460e2b",
  null
  
)

export default component.exports